import { useDispatch, useSelector } from "react-redux";
import QueryBuilder from "react-querybuilder";
import { getQueryOperators } from "../../../../components/querybuilder/queryoperators";
import { QueryValueEditor } from "../../../../components/querybuilder/queryvalueeditor";

import { FormRegion } from "../../../../components/formregion";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { getJsonDateStringFromDateKey, updateRuleAtPath } from "../../../../lib/utils";

const FilterStep = (props) => {
  //#region state
  const { formValues } = props;
  const pageState = useSelector((state) => state.createSchedulePage);

  const { t } = useTranslation();

  useEffect(() => {
    const datasets = pageState.formValues.Datasets;
    const widgetId = pageState.formValues.widgetId;

    // Guard: no datasets
    if (!datasets || datasets.length === 0) return;

    // Case 1: No widget → use first dataset
    if (datasets[0]?.Id > 0 && widgetId <= 0) {
      props.loadFilterDataFromDataset(datasets[0].Id);
      return;
    }

    // Case 2: Existing widget → use widget's dataset
    if (widgetId > 0) {
      const widget = pageState.formValues.Widgets?.find(
        (w) => w.Id === widgetId,
      );

      if (widget?.DatasetId) {
        props.loadFilterDataFromDataset(widget.DatasetId);
      }
    }
  }, [pageState.formValues.widgetId]);

  const getOperators = (fieldName) => {
    let field = pageState.currentDataset.Where[fieldName];
    if (!field) return [];

    return getQueryOperators(field.DataTypeId, field.IsLookup);
  };
 
  const handleKeyChange = (keyId, path) => {
    const currentQuery = pageState.formValues.WhereObject;
    const updatedQuery = updateRuleAtPath(currentQuery, path, keyId);
    props.onChangeFormValue("WhereObject", updatedQuery, props.onChange);
  };

  //#endregion

  return (
    <FormRegion>
      <div className="form-region-filter">
        <div className="form-group form-group-1">
          <QueryBuilder
            query={pageState.formValues.WhereObject}
            fields={pageState.currentDataset.Where}
            getOperators={getOperators}
            onQueryChange={(q) => {
              props.onChangeFormValue("WhereObject", q, props.onChange);
            }}
            controlElements={{
              valueEditor: (editorProps) => (
                <QueryValueEditor
                  {...editorProps}
                  handleSaveKey={handleKeyChange}
                />
              ),
            }}
            showCloneButtons={true}
          />
        </div>
      </div>
      <style>
        {`
            /*filter section*/
            .create-schedule-page-form .form-region-filter
            {
                margin-top: 36px!important;
                border-radius: 4px;*/
                padding: 8px 0px 8px 0px;
            }

            .create-schedule-page-form .form-region-filter .header
            {
                padding: 4px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.08);
            }

            .create-schedule-page-form .form-region-filter .header .right-line
            {
                display: none;
            }

            .create-schedule-page-form .form-region-filter .content
            {
                padding-left: 12px;
                margin-top: 12px;
            }
            
            .create-schedule-page-form .form-region-filter .form-region-root
            {
            }       
            

            /*query builder*/
            .create-schedule-page-form .form-region-filter .ruleGroup, .create-schedule-page-form .form-region-filter .ruleGroup-combinators,
            .create-schedule-page-form .form-region-filter .ruleGroup-addRule, .create-schedule-page-form .form-region-filter .ruleGroup-addGroup,
            .create-schedule-page-form .form-region-filter .rule-remove, .create-schedule-page-form .form-region-filter .ruleGroup-remove,
            .create-schedule-page-form .form-region-filter .rule-fields, .create-schedule-page-form .form-region-filter .rule-operators,
            .create-schedule-page-form .form-region-filter .rule-value, .create-schedule-page-form .form-region-filter .rule-cloneRule
            {
                border-color: rgba(0, 0, 0, 0.06);
                background-color: #fff;
                color: #424242;                                               
            }

            .create-schedule-page-form .form-region-filter .rule-fields:focus, .create-schedule-page-form .form-region-filter .rule-operators:focus,
            .create-schedule-page-form .form-region-filter .rule-value:focus
            {
                outline: none
            }    
            
            .create-schedule-page .form-region-filter .rule-remove, .create-schedule-page .form-region-filter .ruleGroup-remove
            {
                color: #d51923;
                padding: 8px 10px 7px 10px;
            }
          `}
      </style>
    </FormRegion>
  );
};

export default FilterStep;
